<template>
  <div class="lg:container lg:mx-auto">
    <Head :title="`Edit Custom Run ${run.id}`" />
    <div class="pr-4">
      <span class="text-sm">Project</span>
      <h1 class="text-4xl font-bold">{{ project.title }}</h1>
      <span class="text-sm">Run name</span>
      <h1 class="mb-8 text-xl font-bold">{{ run.name }}</h1>
    </div>
    <!-- Title -->

    <div class="flex w-full mb-4">
      <div class="w-1/2 mr-10">
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-1/2 font-bold text-black">System</p>
          <p class="text-blue-400">{{ run.title }}</p>
        </div>
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-1/2 font-bold text-black">Drainage Width</p>
          <p class="text-blue-400">{{ run.width }}</p>
        </div>
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-1/2 font-bold text-black">Drainage Edge</p>
          <p class="text-blue-400">{{ run.edge }}</p>
        </div>
        <div class="flex items-center py-2 mb-2">
          <p class="w-1/2 text-xl font-bold text-black">Grate</p>
          <p class="w-1/2 text-blue-400">{{ run.grate }}</p>
        </div>
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-1/2 font-bold text-black">Load Class</p>
          <p class="flex items-center text-blue-400">
            <class-icon :name="run.loadClass.icon" class="flex-shrink-0 w-8 h-8 mx-2 fill-blue-800" />
            {{ run.loadClass.name }}
          </p>
        </div>
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-1/2 font-bold text-black">Material</p>
          <p class="text-blue-400"> {{ run.material }}</p>
        </div>
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-1/2 font-bold text-black">Compliances</p>
          <div class="flex items-center text-blue-400">
            <div
              v-for="c in run.compliances"
              :key="c.id"
              class="border rounded-md py-1 border-blue-400  flex items-center mx-0.5" :alt="c.name"
            >
              <compliance-icon :name="c.icon" class="flex-shrink-0 w-4 h-4 mx-1 fill-blue-800" />
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/2">
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-2/4 font-bold text-black">Total Run Length</p>
          <p class="text-blue-400">Manual</p>
        </div>
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-2/4 font-bold text-black">Overall Channel Depth:</p>
          <p class="text-blue-400">TBD</p>
        </div>
        <!-- <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-2/4 font-bold text-black">Constant Depth or Sloped Depth</p>
          <p class="text-blue-400">&nbsp;</p>
        </div> -->
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-2/4 font-bold text-black">Outlet Configuration</p>
          <p class="w-2/4 text-blue-400"> {{ outlet?.name }}</p>
        </div>
        <!-- <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-2/4 font-bold text-black">Outlet Type</p>
          <p class="text-blue-400">&nbsp;</p>
        </div> -->
        <div class="flex items-center py-2 mb-2 border-b">
          <p class="w-2/4 font-bold text-back">Outlet Size</p>
          <p class="text-blue-400"> TBD</p>
        </div>
      </div>
    </div>
    <!-- Run details -->

    <div class="flex items-center my-2 border-t border-blue-800 border-solid"> &nbsp;</div>

    <div class="flex flex-row justify-between mb-6 aligns-center">
      <div class="flex-auto">
        <p class="mb-4 font-bold">Select Outlet Configuration</p>
        <div class="flex flex-row">
          <a
            v-for="o in outlets"
            :key="o.id "
            class="flex flex-col items-center px-2 py-1 mx-2 border-2 border-solid cursor-pointer"
            :class="form.outlet == o.id ? 'shadow-lg border-blue-300 text-blue-600' : 'text-gray-400'"
            @click="setOutlet(o)"
          >
            <svg-image :name="o.id" class="w-20 h-6 p-2" />
            <p class="mt-2">{{ o.name }}</p>
          </a>
        </div>
        <div v-if="form.errors.outlet" class="form-error">{{ form.errors.outlet }}</div>
      </div>
      <!-- outlet-configuration -->
      <div class="flex flex-row items-center justify-end w-2/4 mb-8">
        <Link class="btn-blue" :href="`/projects/${project.id}`">
          <span> Back to Project</span>
        </Link>
      </div>
    </div>
    <!-- Bulk Actions -->


    <div class="mb-12 overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-lg font-bold text-left">
            <th class="pt-2 pr-2">Position</th>
            <th class="pt-2 pr-4">Part</th>
            <th class="pt-2 pr-4">Description</th>
            <th class="pt-2 text-center">Actions</th>
          </tr>
        </thead>
        <draggable
          v-model="form.parts"
          item-key="index"
          tag="tbody"
        >
          <template #item="{ element, index }">
            <tr class="cursor-move hover:bg-gray-100 focus-within:bg-gray-100" :class="index % 2 == 0 ? '' : 'bg-gray-100'">
              <td class="w-1 text-center">
                {{ index + 1 }}
              </td>
              <td class="w-1/4">
                <span class="flex items-center p-2 focus:text-blue-500">
                  {{ element.part_number }}
                  <icon v-if="element.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 ml-2 fill-gray-400" />
                </span>
              </td>
              <td class="w-auto">
                {{ element.description }}
              </td>
              <td class="w-1/4">
                <div class="flex items-center justify-end">
                  <button v-if="element.type != 'section'" class="p-2" type="button" title="Add Next" @click="clone(element)"><icon name="clone" class="block w-4 h-4" /></button>
                  <button v-if="element.type != 'section'" class="p-2" type="button" title="Add Last" @click="duplicate(element)"><icon name="duplicate" class="block w-4 h-4" /></button>
                  <button class="p-2" type="button" title="Delete Part" @click="remove(index)"><icon name="trash" class="block w-4 h-4" /></button>
                </div>
              </td>
            </tr>
          </template>
        </draggable>
        <tfoot>
          <tr v-if="form.parts.length < 1">
            <td class="px-6 py-4 text-xl text-center border-t" colspan="6">No parts found.</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="flex items-center float-right py-4">
      <add-part :parts="parts" @input="add($event)" />
      <loading-button :loading="form.processing" class="px-10 btn-blue" @click="update()">Save</loading-button>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import ClassIcon from '@/Shared/LoadClassesIcon'
import ComplianceIcon from '@/Shared/CompliancesIcon'
import LoadingButton from '@/Shared/LoadingButton'
import AddPart from './Add.vue'
import SvgImage from '@/Shared/SvgImage'
import draggable from 'vuedraggable'

export default {
  components: {
    Head,
    Icon,
    Link,
    ClassIcon,
    ComplianceIcon,
    LoadingButton,
    AddPart,
    SvgImage,
    draggable,
  },
  layout: Layout,
  props: {
    project: Object,
    run    : Object,
    parts  : Array,
    outlets: Array,
  },
  remember: ['form'],
  data () {
    return {
      form: this.$inertia.form({
        outlet: this.run.outlet,
        parts: this.run.parts,
      }),
    }
  },
  computed: {
    outlet () {
      return this.outlets.find(el => el.id == this.form.outlet)
    },
  },
  mounted() {
  },
  methods:{
    update() {
      this.form.put(`/customs/${this.run.id}`, {
        preserveState: true,
        onBefore: () => {},
        onSuccess: () => {},
      })
    },
    add(parts) {
      this.form.parts.push(...parts)
    },
    clone (part) {
      let index = this.form.parts.indexOf(part)
      if (index != -1) {
        this.form.parts.splice(index, 0, part)
      }
    },
    duplicate (part) {
      this.form.parts.push(part)
    },
    remove(index){
      if (this.form.parts[index].type == 'section') {
        this.form.outlet = 1
      }

      this.form.parts.splice(index, 1)
    },
    move(from, to) {
      let el = this.form.parts[from]
      this.form.parts.splice(from, 1)
      this.form.parts.splice(to, 0, el)
    },
    setOutlet(outlet) {
      this.form.outlet = outlet.id
      let section = this.form.parts.findIndex(el => el.type == 'section')
      if (section > -1) {
        this.remove(section)
      }

      if (this.form.outlet == 1) {
        return
      }

      this.form.parts.push({
        id: 0,
        type: 'section',
        part_number: outlet.name +  ' Position',
        description: 'Direction change position',
      })
    },
  },
}
</script>
